import React from "react";
import "./ArrowButton.scss";
import PropTypes from "prop-types";
import classNames from "classnames";

// const nextSVG = <svg width="11" height="20" viewBox="0 0 11 20" fill="#005AAB" xmlns="http://www.w3.org/2000/svg">
// <path d="M.931 0a.969.969 0 01.714.317l8.319 8.478a.771.771 0 01.317.713.771.771 0 01-.317.713l-8.319 8.478a.911.911 0 01-1.347 0 1 1 0 010-1.426l7.606-7.765L.298 1.743a1 1 0 010-1.426A.719.719 0 01.931 0z" strokeWidth="0"/>
// </svg>

const nextSVG = <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" viewBox="0 0 15 25" fill="#005AAB" strokeWidth="0">
  <path d="M1.7.5c.3 0 .6.1.9.4l10.5 10.7c.3.2.4.5.4.9s-.1.7-.4.9L2.6 24.1c-.5.5-1.3.5-1.7 0-.5-.5-.5-1.3 0-1.8l9.6-9.8L.9 2.7C.4 2.2.4 1.4.9.9c.2-.3.5-.4.8-.4z"/>
</svg>

const prevSVG = <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" viewBox="0 0 15 25" fill="#005AAB" strokeWidth="0">
  <path d="M12.3 24.5c-.3 0-.6-.1-.9-.4L.9 13.4c-.3-.2-.4-.5-.4-.9s.1-.7.4-.9L11.4.9c.5-.5 1.3-.5 1.7 0 .5.5.5 1.3 0 1.8l-9.6 9.8 9.6 9.8c.5.5.5 1.3 0 1.8-.2.3-.5.4-.8.4z"/>
</svg>

// const prevSVG = <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M10 1L1 10C1 10 6.8048 15.7909 10 19" stroke="#005AAB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// </svg>


const ArrowButton = ({direction, onClick }) => {
  return (
    <button 
      className={classNames({
        "arrow-button": true,
        "arrow-button--disabled": onClick === null,
        [`arrow-button--${direction}`]: true,
        })}
      onClick={onClick}>
      {direction === "next" ? nextSVG : prevSVG}
    </button>
  );
};

ArrowButton.defaultProps = {
  direction: "next"
}

ArrowButton.propTypes = {
  onClick: PropTypes.func,
  direction: PropTypes.string,
};

export default ArrowButton;